// File Metadata:
// Filename: ScheduleCheckupDialog.js
// Version: 1.00
// Created: 2025-03-28 19:48:00
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useState } from 'react'
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, FormControl, InputLabel,
    Select, MenuItem, Stack, Alert
} from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { useScheduleCheckupMutation } from '../../api/medicalApiSlice'

const ScheduleCheckupDialog = ({ open, onClose, userId }) => {
    const [scheduleCheckup] = useScheduleCheckupMutation()
    const [checkupDate, setCheckupDate] = useState(null)
    const [type, setType] = useState('')
    const [error, setError] = useState('')

    const handleSubmit = async () => {
        if (!checkupDate || !type) {
            setError('Please fill in all fields')
            return
        }

        try {
            await scheduleCheckup({
                userId,
                checkupDate: checkupDate.toISOString(),
                type
            }).unwrap()
            onClose()
        } catch (err) {
            setError(err.data?.message || 'Failed to schedule checkup')
        }
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Schedule Medical Checkup</DialogTitle>
            <DialogContent>
                <Stack spacing={3} sx={{ mt: 2 }}>
                    {error && <Alert severity="error">{error}</Alert>}
                    
                    <DatePicker
                        label="Checkup Date"
                        value={checkupDate}
                        onChange={setCheckupDate}
                        renderInput={(params) => <TextField {...params} />}
                    />

                    <FormControl fullWidth>
                        <InputLabel>Type</InputLabel>
                        <Select
                            value={type}
                            label="Type"
                            onChange={(e) => setType(e.target.value)}
                        >
                            <MenuItem value="ANNUAL">Annual Checkup</MenuItem>
                            <MenuItem value="EQUIPMENT_SPECIFIC">Equipment Certification</MenuItem>
                            <MenuItem value="RETURN_TO_WORK">Return to Work</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit} variant="contained">Schedule</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ScheduleCheckupDialog
